import { selectContentFromAppState } from '~src/spacesPlatform/selectors/ContentSelectors';

import { getAppStore } from '../../bootstrap/redux/store/AppStore';
import { WebClientListResourceFetcher } from '../../httpClient/fetchers/resourceFetchers/WebClientListResourceFetcher';
import { ResourceQuery } from '../../httpClient/resources/ResourceQuery';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { WebHttpClientWithErrorToastInstance } from '../../httpClient/WebHttpClientWithErrorToast';
import { IExplorableItemTypeInfo } from '../../spacesPlatform/models/resourceInfoParts';
import { BackgroundJobAllowedActions } from './BackgroundJobAllowedActions';
import { BackgroundJobStatus, BackgroundJobTaskType } from './BackgroundJobInfo';
import { CancelBackgroundJobRequest, ICancelBackgroundJobParams } from './CancelBackgroundJobRequest';
import { GetBackgroundJobsRequest, IGetBackgroundJobsResult } from './GetBackgroundJobsRequest';
import { IBackgroundJob } from './IBackgroundJob';

export interface IBackgroundJobInfo extends IBackgroundJob, IExplorableItemTypeInfo<'backgroundJob'> {
}

export namespace BackgroundJobsService {
  export const backgroundJobsResponseMapper = (result: IGetBackgroundJobsResult): IBackgroundJobInfo[] =>
    result.backgroundJobs.map((j: IBackgroundJob) => {
      return {
        ...j,
        contentType: 'backgroundJob',
        id: j.jobId + '',
      } as IBackgroundJobInfo; // Typescript can't infer whether 'backgroundJobs' is a string or 'backgroundJobs'
  });
  export function all(): ResourceQuery<IBackgroundJobInfo> {
    const fetcher = new WebClientListResourceFetcher(GetBackgroundJobsRequest, backgroundJobsResponseMapper);
    return new ResourceQuery(fetcher);
  }

  export function actions(id: string): Promise<BackgroundJobAllowedActions> {
    const items = selectContentFromAppState(getAppStore().getState());
    const backgroundJob: IBackgroundJobInfo | undefined = items.find((item: IBackgroundJobInfo) => item.jobId + '' === id) as IBackgroundJobInfo;
    if (!backgroundJob) {
      throw new Error('Failed to find background job with id ' + backgroundJob.jobId);
    }
    const incomplete = backgroundJob.status === BackgroundJobStatus.Pending || backgroundJob.status === BackgroundJobStatus.InProgress;
    const isSystemJob = backgroundJob.taskType === BackgroundJobTaskType.System;
    const cancelBackgroundJob = incomplete && !isSystemJob;
    return Promise.resolve({ cancelBackgroundJob });
  }

  export function cancelBackgroundJob(cancelParms: ICancelBackgroundJobParams): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequestAndDelay(new CancelBackgroundJobRequest(cancelParms));
  }
}
